import { useSeverityColor, isSeverityColor } from "src/hooks/useSeverityColor";
import { SenecBaseTheme } from "src/styles/senecBaseTheme";
import { TableCardEntry } from "src/components/cards/senec-tile/dataTypes";
import { useTheme } from "@mui/material";

export const groupedDataHasIcons = (data: Record<string, TableCardEntry[]>) => {
    for (const entries of Object.values(data)) {
        for (const entry of entries) {
            if (entry.endAdornment?.icon !== undefined) {
                return true;
            }
        }
    }

    return false;
};

export const dataHasIcons = (data: TableCardEntry[]) => {
    for (const entry of data) {
        if (entry.endAdornment?.icon !== undefined) {
            return true;
        }
    }

    return false;
};

export const useEntryColor = () => {
    const theme: SenecBaseTheme = useTheme();
    const { getColor: getSeverityColor } = useSeverityColor();
    const defaultColor = theme.palette.neutralGray70.main;

    const getColor = (color: string | undefined) => {
        const entryColor = color ?? defaultColor;
        return isSeverityColor(entryColor) ? getSeverityColor(entryColor) : entryColor;
    };

    const getTextColor = (data: TableCardEntry) => {
        return getColor(data.color);
    };

    const getIconColor = (data: TableCardEntry) => {
        if (textColorIsDefined(data)) return getTextColor(data);
        return getColor(data.endAdornment?.color);
    };

    const getDefaultColor = () => defaultColor;

    const textColorIsDefined = (data: TableCardEntry) => data.color !== undefined;

    return { getColor, textColorIsDefined, getTextColor, getIconColor, getDefaultColor };
};
